export const objectIdRegex = /^[0-9a-fA-F]{24}$/;
